export const STATUS_PENDING = 'pending'
export const STATUS_ONLINE = 'success'
export const STATUS_OFFLINE = 'offline'
export const STATUS_SPEAKING = 'speaking'
export const STATUS_HOLDING = 'pending'
export const STATUS_OUTGOING = 'outgoing'
export const STATUS_TRANSFER = 'transfer'
export const STATUS_AFTER_CALL = 'after_call'
export const INCOMING = 'INCOMING'
